import { useState, useEffect } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { Center, Spinner } from "@chakra-ui/react";
import axios from "axios";

const OTP_BASE_URL = process.env.REACT_APP_LOYALTY_OTP_ENDPOINT;

export default function NotVerifiedGuard() {
  const [status, setStatus] = useState("loading");

  useEffect(() => {
    const checkAccess = async () => {
      try {
        const phone = sessionStorage.getItem("registeredPhone");
        if (!phone) {
          setStatus("unauthorized");
          return;
        }

        const response = await axios.get(`${OTP_BASE_URL}/check-phone`, {
          params: { phone },
        });

        const data = response.data?.data;
        if (!data?.exists) {
          setStatus("unauthorized");
          return;
        }

        if (data.verificationStatus === "verified") {
          setStatus("verified");
        } else {
          setStatus("not_verified");
        }
      } catch {
        setStatus("unauthorized");
      }
    };

    checkAccess();
  }, []);

  if (status === "loading") {
    return (
      <Center h="100vh">
        <Spinner size="xl" color="#113A70" />
      </Center>
    );
  }

  if (status === "unauthorized") {
    return <Navigate to="/home" replace />;
  }

  if (status === "verified") {
    return <Navigate to="/success" replace />;
  }

  return <Outlet />;
}
